import { BUSCAR_TRECHOS, LIMPAR_TRECHOS } from '../../actions/types'

const initialState = undefined

export default function reducerBuscarTrechos (state = [], action = initialState) {
  switch (action.type) {
    case BUSCAR_TRECHOS: {
      const trechos = action.payload.data;

      if (trechos) {
        return trechos
      }
      return []
    }
    case LIMPAR_TRECHOS:
      return []

    default: {
      return state
    }
  }
}
